import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import get from 'lodash-es/get';

import { SIDEBAR_VIEWS } from '../../lib/constants';
import AboutLocationSidebar from './AboutLocation';
import CollectionSidebar from './Collection';
import DataManagerSidebar from './DataManager';
import FeatureDetailSidebar from './Feature';
import FeatureEditorSidebar from './Feature/FeatureEditor';
import FeatureIconEditorSidebar from './Feature/FeatureEditor/FeatureIconEditor';
import HelpSidebar from './Help';
import HistoricalImagerySidebar from './HistoricalImagery'
import ImportSidebar from './Import';
import KeyboardShortcutsSidebar from './KeyboardShortcuts';
import LayerCategoryDetailSidebar from './Layers/LayerCategoryDetail';
import LayerCategoryListSidebar from './Layers/LayerCategoryList';
import LibrarySidebar from './Library';
import LoaderSidebar from './Loader-WIP'
import SavedSidebar from './Saved';
import SelectedFeaturesSidebar from './SelectedFeatures';
import SettingsSidebar from './Settings';
import styles from './Sidebar.module.scss';
import TerrainToolsSidebar from './TerrainTools';
import UserProfileSidebar from './UserProfile';


function SidebarRouter(props) {
  const routeMap = {
    [SIDEBAR_VIEWS.AboutLocation]: AboutLocationSidebar,
    [SIDEBAR_VIEWS.Collection]: CollectionSidebar,
    [SIDEBAR_VIEWS.Content]: SavedSidebar,
    [SIDEBAR_VIEWS.DataManager]: DataManagerSidebar,
    [SIDEBAR_VIEWS.FeatureDetail]: FeatureDetailSidebar,
    [SIDEBAR_VIEWS.FeatureEditor]: FeatureEditorSidebar,
    [SIDEBAR_VIEWS.FeatureIconEditor]: FeatureIconEditorSidebar,
    [SIDEBAR_VIEWS.Help]: HelpSidebar,
    [SIDEBAR_VIEWS.Import]: ImportSidebar,
    [SIDEBAR_VIEWS.KeyboardShortcuts]: KeyboardShortcutsSidebar,
    [SIDEBAR_VIEWS.LayerCategoryDetail]: LayerCategoryDetailSidebar,
    [SIDEBAR_VIEWS.LayerCategoryList]: LayerCategoryListSidebar,
    [SIDEBAR_VIEWS.Library]: LibrarySidebar,
    [SIDEBAR_VIEWS.Loader]: LoaderSidebar,
    [SIDEBAR_VIEWS.SelectedFeatures]: SelectedFeaturesSidebar,
    [SIDEBAR_VIEWS.Settings]: SettingsSidebar,
    [SIDEBAR_VIEWS.TerrainTools]: TerrainToolsSidebar,
    [SIDEBAR_VIEWS.HistoricalImagery]: HistoricalImagerySidebar,
    [SIDEBAR_VIEWS.User]: UserProfileSidebar,
  };
  let CompFunc = get(routeMap, [props.view], null);

  return <CompFunc {...props.metadata} />;

  // return get(routeMap, [props.view], null);
}

SidebarRouter.propTypes = {
  view: PropTypes.string,
  metadata: PropTypes.object,
};

function Sidebar(props) {
  const sideBarStyles = props.useMinimalSidebar ? styles.minimumSidebar : styles.fullSidebar
  return (
    <div className={sideBarStyles} style={{ display: props.showSidebar ? 'flex' : 'none'}}>
      {props.sidebarView.view && <SidebarRouter {...props.sidebarView} />}
    </div>
  );
}

Sidebar.propTypes = {
  showSidebar: PropTypes.bool,
  sidebarView: PropTypes.object,
  useMinimalSidebar: PropTypes.bool,
};

export default connect((model) => {
  const { sidebarView, showSidebar } = model.app
  const useMinimalSidebar = [SIDEBAR_VIEWS.HistoricalImagery].includes(sidebarView.view)
  return {
    showSidebar,
    sidebarView,
    useMinimalSidebar
  };
})(Sidebar);
